// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const McpIcon = createSvgIcon(
  <svg fill="currentColor" fillRule="evenodd" viewBox="0 0 24 24">
    <path d="M15.69 2.34a2.6 2.6 0 0 0-3.61 0l-9.63 9.44a.86.86 0 0 1-1.2 0 .8.8 0 0 1 0-1.18l9.63-9.44a4.3 4.3 0 0 1 6.01 0 4.1 4.1 0 0 1 1.2 3.54 4.3 4.3 0 0 1 3.61 1.18l.05.05a4.1 4.1 0 0 1 0 5.9l-8.7 8.54a.27.27 0 0 0 0 .4l1.79 1.75a.8.8 0 0 1 0 1.18.86.86 0 0 1-1.2 0l-1.8-1.76a1.9 1.9 0 0 1 0-2.75l8.71-8.54a2.47 2.47 0 0 0 0-3.54l-.05-.05a2.6 2.6 0 0 0-3.6 0l-7.18 7.03-.1.1a.86.86 0 0 1-1.2 0 .8.8 0 0 1 0-1.18l7.27-7.13a2.47 2.47 0 0 0 0-3.54" />
    <path d="M14.49 4.7a.8.8 0 0 0 0-1.18.86.86 0 0 0-1.2 0l-7.13 6.99a4.1 4.1 0 0 0 0 5.9 4.3 4.3 0 0 0 6.02 0l7.12-6.99a.8.8 0 0 0 0-1.18.86.86 0 0 0-1.2 0l-7.13 6.99a2.6 2.6 0 0 1-3.6 0 2.47 2.47 0 0 1 0-3.54z" />
  </svg>,
  "Mcp",
);
export default McpIcon;
